import { render, staticRenderFns } from "./ChildAdminDepartment.vue?vue&type=template&id=2da672f6&scoped=true&"
import script from "./ChildAdminDepartment.vue?vue&type=script&lang=ts&"
export * from "./ChildAdminDepartment.vue?vue&type=script&lang=ts&"
import style0 from "./ChildAdminDepartment.vue?vue&type=style&index=0&id=2da672f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da672f6",
  null
  
)

export default component.exports